<template>
  <div class="blog-Management-modular">
    <div class="blog-body-modular">
      <el-row :gutter="90">
        <el-col :span="16" :xs="24">
          <div class="blog-body-left-modular">
            <div class="banner-modular">
              <el-carousel :height="bannerHeight" :autoplay="false">
                <el-carousel-item
                  v-for="(item, index) in bannerImg"
                  :key="index"
                >
                  <img
                    class="banner-img"
                    :src="item.img"
                    alt=""
                    @click="toBolgDeatil(item.id)"
                  />
                  <div class="news-item-title">
                    {{ currLanguage == 3 ? item.eng_title : item.title }}
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="news-modualr" v-loading="newListLoading">
              <el-tabs v-model="activeBlogTypeId" @tab-click="handleClick">
                <el-tab-pane
                  :label="
                    currLanguage == 3 ? item1.eng_type_name : item1.type_name
                  "
                  :name="item1.id"
                  v-for="(item1, index1) in blogTypeData"
                  :key="index1"
                >
                  <div v-if="newList.length == 0" class="my-evaluate-bodu-none">
                    <img
                      class="none-icon"
                      src="../assets/public/none-icon.png"
                      alt=""
                    />
                    <p class="none-title">
                      {{ $t("translateText.NoDataText") }}
                    </p>
                  </div>
                  <div
                    class="news-list-item-modular"
                    v-else
                    v-for="(item, index) in newList"
                    :key="index"
                  >
                    <el-row :gutter="20">
                      <el-col :span="8" :xs="24">
                        <div class="news-item-left">
                          <img
                            class="news-item-img"
                            @click="toBolgDeatil(item.id)"
                            :src="item.cover"
                            alt=""
                          />
                        </div>
                      </el-col>
                      <el-col :span="16" :xs="24">
                        <div class="news-item-right">
                          <div
                            class="news-item-title"
                            @click="toBolgDeatil(item.id)"
                          >
                            {{
                              currLanguage == 3 ? item.eng_title : item.title
                            }}
                          </div>
                          <div class="news-item-content">
                            <div v-html="item.detail"></div>
                            <!-- <div>
                              {{
                                currLanguage == 3
                                  ? item.eng_description
                                  : item.description
                              }}
                            </div> -->
                          </div>
                          <div class="news-item-publisher-date-modular">
                            <div class="news-item-publisher-date">
                              <div class="news-item-publisher">
                              <!-- <span class="news-item-tags">{{ item.tasgs }}</span>/ -->
                              <span class="news-item-tags">文</span>/
                              {{ item.writer }}
                              </div>
                              <div class="news-item-date">
                                {{ changeTime(item.create_time) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-tab-pane>
                <!-- <el-tab-pane label="贴片生产" name="second">配置管理</el-tab-pane>
                <el-tab-pane label="用户手册" name="third">角色管理</el-tab-pane>
                <el-tab-pane label="公司新闻" name="fourth">定时任务补偿</el-tab-pane> -->
              </el-tabs>
            </div>
            <div class="pagination-footer-modualr" v-if="pageCount > 1">
              <el-pagination
                :pager-count="11"
                background
                layout="prev, pager, next"
                :total="pageCount"
                @current-change="handleCurrentChange()"
              >
              </el-pagination>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xs="24">
          <div class="blog-body-right-modular">
            <div class="search-header-modualr">
              <el-input
                class="search-input"
                size="medium"
                :placeholder="pageTextArr[0]"
                suffix-icon="el-icon-search"
                v-model="searchKey"
                @change="searchBlogList()"
              >
              </el-input>
            </div>
            <div class="division-line"></div>
            <div class="hot-blog-modular">
              <div class="hot-blog-title">
                {{ pageTextArr[1] }}
              </div>
              <div class="hot-blog-division-line"></div>
              <div v-if="hotBlogList.length == 0" class="my-evaluate-bodu-none">
                <img
                  class="none-icon"
                  src="../assets/public/none-icon.png"
                  alt=""
                />
                <p class="none-title">{{ pageTextArr[3] }}~</p>
              </div>
              <div class="hot-blog-list-modualr" v-else>
                <div
                  class="hot-blog-item"
                  v-for="(item, index) in hotBlogList"
                  :key="index"
                  @click="toBolgDeatil(item.id)"
                >
                  <div class="hot-blog-item-top" v-if="index < 2">
                    <img
                      class="hot-blog-item-top-img"
                      :src="item.cover"
                      alt=""
                    />
                    <div class="hot-blog-item-top-title">
                      {{ currLanguage == 3 ? item.eng_title : item.title }}
                    </div>
                    <img
                      class="top-icon"
                      v-if="index == 0"
                      src="../assets/blog/top1-icon.png"
                      alt=""
                    />
                    <img
                      class="top-icon"
                      v-else
                      src="../assets/blog/top2-icon.png"
                      alt=""
                    />
                  </div>
                  <div class="hot-blog-item-other" v-else>
                    <el-row :gutter="10">
                      <el-col :span="8">
                        <div class="hot-blog-item-other-img">
                          <img
                            class="item-other-img"
                            :src="item.cover"
                            alt=""
                          />
                          <img
                            class="top-icon"
                            v-if="index == 2"
                            src="../assets/blog/top3-icon.png"
                            alt=""
                          />
                          <img
                            class="top-icon"
                            v-if="index == 3"
                            src="../assets/blog/top4-icon.png"
                            alt=""
                          />
                          <img
                            class="top-icon"
                            v-if="index == 4"
                            src="../assets/blog/top5-icon.png"
                            alt=""
                          />
                        </div>
                      </el-col>
                      <el-col :span="16">
                        <div class="hot-blog-item-other-info">
                          <div class="hot-blog-item-other-title">
                            {{
                              currLanguage == 3 ? item.eng_title : item.title
                            }}
                          </div>
                          <div class="hot-blog-item-other-date">
                            {{ changeTime(item.create_time)  }}
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>
            <div class="division-line"></div>
            <div class="newsest-blog-modualr">
              <div class="newsest-blog-title">
                {{ pageTextArr[2] }}
              </div>
              <div class="newsest-blog-division-line"></div>
              <div
                v-if="newestBlogList.length == 0"
                class="my-evaluate-bodu-none"
              >
                <img
                  class="none-icon"
                  src="../assets/public/none-icon.png"
                  alt=""
                />
                <p class="none-title">{{ pageTextArr[3] }}~</p>
              </div>
              <div
                class="newsest-blog-item"
                v-else
                v-for="(item, index) in newestBlogList"
                :key="index"
                @click="toBolgDeatil(item.id)"
              >
                <img
                  class="right-tag-icon"
                  src="../assets/blog/red-right-tag-icon.png"
                  alt=""
                />
                <span class="newsest-blog-conent">{{
                  currLanguage == 3 ? item.eng_title : item.title
                }}</span>
                <div class="newsest-blog-date">{{ changeTime(item.create_time) }}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabActiveLable: "锦格之家",
      activeBlogTypeId: "",
      searchKey: "", //搜索关键词
      blogTypeData: [], //博客类型列表
      page: 1,
      pageSize: 10,
      pageCount: 0, //总页数
      bannerImg: [], //轮播
      newList: [], //博客
      newListLoading: false, //loading
      hotBlogList: [], //热门博客
      newestBlogList: [], //最新博客
      bannerHeight: "300px",
      currLanguage: localStorage.getItem("curLanguageType"), //当前语言
      pageTextArr: ["请输入关键词", "热门博客", "最新博客", "暂无数据"],
    };
  },
  methods: {
    /**
     *
     * @param {*} tab
     * @param {*} event
     */
    handleClick(tab, event) {
      let that = this;
      // console.log(tab.label);
      that.tabActiveLable = tab.label;
      // 博客列表
      that.getBlogList();
    },
    // 判断是手机还是PC
    judgePcOrPhone() {
      let that = this;
      let type = localStorage.getItem("equipmentType");
      if (type == 1) {
        that.bannerHeight = "220px";
      } else {
        that.bannerHeight = "300px";
      }
    },

    /**
     * 获取博客类型列表
     */
    getBlogType() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 100,
      };

      this.$http.getBlogType(
        data,
        (res) => {
          if (res.ret == 1) {
            that.blogTypeData = res.data.reverse();
            if (
              that.blogTypeData.length > 0 &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.translateApiData(
                that.blogTypeData,
                "type_name",
                "blogTypeData"
              );
            }

            that.activeBlogTypeId = that.blogTypeData[0].id;
            // 博客列表
            that.getBlogList();
            // 获取banner
            that.getBannerImg();
            // 获取热门 - 最新博客
            that.getHotAndHotBlogList();
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 分页点击
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.page = val;
      this.getBlogList();
    },

    /**
     * 获取博客列表
     */
    getBlogList() {
      let that = this;
      // loading
      that.newListLoading = true;
      let data = {
        page: that.page,
        pagesize: that.pageSize,
        type_id: that.activeBlogTypeId,
      };

      this.$http.blogList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.newList = res.blogList;
            that.newListLoading = false;

            if (
              that.newList.length > 0 &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.translateApiData(that.newList, "title", "newList");
            }
            if (
              that.newList.length > 0 &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.translateApiData(that.newList, "description", "newList");
            }
            that.pageCount = parseInt(res.total);
          } else {
            that.newListLoading = false;
            that.newList = res.blogList;
            that.pageCount = 0;
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          that.newListLoading = false;
        }
      );
    },

    /**
     * 获取热门 - 最新博客
     */
    getHotAndHotBlogList() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pageSize,
        type_id: that.activeBlogTypeId,
      };

      this.$http.blogList(
        data,
        (res) => {
          if (res.ret == 1) {
            // 热门
            that.hotBlogList = res.hotList;
            // 最新
            that.newestBlogList = res.newList;
            if (
              that.hotBlogList.length > 0 &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.translateApiData(that.hotBlogList, "title", "hotBlogList");
            }
            if (
              that.newestBlogList.length > 0 &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.translateApiData(
                that.newestBlogList,
                "title",
                "newestBlogList"
              );
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取轮播图片 bannerImg
     */
    getBannerImg() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pageSize,
        type_id: that.activeBlogTypeId,
      };
      this.$http.blogList(
        data,
        (res) => {
          if (res.ret == 1) {
            res.blogList.forEach((v, i) => {
              if (i < 3) {
                that.bannerImg.push({
                  img: v.cover,
                  id: v.id,
                  title: v.title,
                  eng_title: v.eng_title,
                });
              }
            });
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 搜索
     */
    searchBlogList() {
      // console.log('searchKey',this.searchKey);
      // return
      this.$router.push({
        path: "/blogsearch",
        query: { searchKey: this.searchKey, typeId: this.activeBlogTypeId },
      });
    },

    /**
     * 跳转博客详情
     * @param {*} blogId
     */
    toBolgDeatil(blogId) {
      this.$router.push({
        path: "/bolgDeatil",
        query: { name: this.tabActiveLable, uuid: blogId },
      });
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },
    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData(data, title, arr_name) {
      let that = this;
      let newTextArr = [];
      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      that.languageTranslateByArr(newTextArr, title, arr_name);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, title, arr_name) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, title, arr_name);
        },
        (res) => {}
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, title, arr_name) {
      let that = this;

      data.forEach((v, i) => {
        if (arr_name == "hotBlogList") {
          that.hotBlogList[i].title = v.translation;
        }
        if (arr_name == "newestBlogList") {
          that.newestBlogList[i].title = v.translation;
        }
        if (arr_name == "blogTypeData") {
          that.blogTypeData[i].type_name = v.translation;
        }
        if (arr_name == "newList" && title == "title") {
          that.newList[i].title = v.translation;
        }
        if (arr_name == "newList" && title == "description") {
          that.newList[i].description = v.translation;
        }
      });
    },
    languageTranslateByArrs(arr) {
      let that = this;
      let newpagetextArr = [];
      that.translateByArr(arr, (res) => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation);
        });
        that.pageTextArr = newpagetextArr;
      });
    },
    changecreateTime(time) {
      let nowTime = new Date();
      let year = nowTime.getFullYear();
      let month = nowTime.getMonth() + 1;
      let date = nowTime.getDate();
      let hour = nowTime.getHours();
      let minute = nowTime.getMinutes();

      let timeArr = time.split(" ");
      let time1 = timeArr[0];
      let time2 = timeArr[1];
      let cyear = time1.split("-")[0];
      let cmonth = time1.split("-")[1];
      let cdate = time1.split("-")[2];
      let chour = time2.split(":")[0];
      let cminute = time2.split(":")[1];
      if (cmonth.split("")[0] == 0) {
        cmonth = cmonth.split("")[1];
      }
      if (cdate.split("")[0] == 0) {
        cdate = cdate.split("")[1];
      }
      if (chour.split("")[0] == 0) {
        chour = cdate.split("")[1];
      }
      if (cminute.split("")[0] == 0) {
        cminute = cminute.split("")[1];
      }

      console.log(year, month, date, hour, minute);
      console.log(cyear, cmonth, cdate, chour, cminute);

      if (
        year == cyear &&
        month == cmonth &&
        date == cdate &&
        hour == chour &&
        minute > cminute
      ) {
        let showTime = Number(minute) - Number(cminute) + "分钟前";
        console.log(showTime);
        return showTime;
      } 
      else if (
        year == cyear &&
        month == cmonth &&
        date == cdate &&
        (Number(hour) - Number(chour)) == 1  &&
        minute < cminute
      ) {
        let showTime = (60 + (Number(minute) - Number(cminute))) + "分钟前";
        console.log(showTime);
        return showTime;
      } 
      else if (
        year == cyear &&
        month == cmonth &&
        date == cdate &&
        (Number(hour)-Number(chour)) >=1 &&
        minute>=cminute
      ) {
        let showTime = Number(hour) - Number(chour) + "小时前";
        console.log(showTime);
        return showTime;
      } 
      else if(year == cyear &&
        month == cmonth &&
        (Number(date) - Number(cdate)) == 1 &&
        hour <= chour&& minute >= cminute){
          let showTime = (24+ (Number(hour) - Number(chour))) + "小时前";
        console.log(showTime);
        return showTime;
        }
        else if(year == cyear &&
        month == cmonth &&
        (Number(date) - Number(cdate)) == 1 &&
        hour <= chour&& minute < cminute){
          let showTime = (23+ (Number(hour) - Number(chour))) + "小时前";
        console.log(showTime);
        return showTime;
        }
        else {
        console.log(time1);
        return time1;
      }
    },
  },
  mounted() {
    let that = this;
    // 判断是手机还是PC
    that.judgePcOrPhone();
    // 博客列表
    that.getBlogType();
    that.languageTranslateByArrs(that.pageTextArr);
    this.changeTime("2023-04-22 16:56:23");
  },
};
</script>


// WEBPACK FOOTER //
// src/view/blogManagement.vue